const locale = {
  'demandList.btn.totalMessage': 'Total: {skuTotal} SKUs, {productTotal} products in total.',
  'demandList.btn.deleteProduct': 'Delete product',
  'demandList.btn.clearQuantity': 'Clear quantity',
  'demandList.btn.exportSelectedProducts': 'Export selected products',
  'demandList.btn.moveToOtherLists': 'Move to other lists',

  'demandList.message.deleting': 'Deleting...',
  'demandList.message.deleteSuccessfully': 'Deleted successfully',
  'demandList.message.deleteFailed': 'Deletion failed',

  'demandList.message.clearing': 'Clearing...',
  'demandList.message.clearQuantitySuccessfully': 'Cleared quantity successfully',
  'demandList.message.clearQuantityFailed': 'Quantity deletion failed',

  'demandList.message.exporting': 'Exporting...',
  'demandList.message.exportFailed': 'Export failed',

  'demandList.exported.message': 'Selected products have been exported',
  'demandList.exported.description': `You can view them in the browser's downloaded files.`,

  'demandList.title': '< Demand List',
  'demandList.inquiry.noproduct': 'Please select a product',
  'demandList.inquiry.productAllZero': 'Please enter the quantity of the product',
  'demandList.inquiry.prompt.title': 'Prompt',
  'demandList.inquiry.quantityprompt.title': 'Prompt',
  'demandList.inquiry.quantityprompt.content':
    'Some items have a quantity of 0. Continuing to inquire about items with a quantity of 0 will not be submitted',
  'demandList.inquiry.quantityprompt.ok': 'Continue Inquiry',
  'demandList.inquiry.quantityprompt.cancel': 'Complete',
  'demandList.inquiry.success': 'Inquiry successful',
  'demandList.inquiry.check.content':
    'Upon confirmation, we will promptly acknowledge your inquiry request. Processing updates will be communicated via email, WhatsApp, or phone',
  'demandList.inquiry.check.clear.content': 'Delete the items submitted this time',
  'demandList.inquiry.check.notclear.content': 'Do not delete the items submitted this time',
  'demandList.inquiry.textarea.placeholder':
    'If you cannot find the accessories you need or have special requirements regarding quality and delivery time, please specify here',
  'demandList.inquiry.attachment.filetypeerror': 'Incorrect file format',
  'demandList.inquiry.attachment.filesizeerror': 'File size exceeds limit',
  'demandList.inquiry.attachment.btn': 'Upload Attachment',
  'demandList.inquiry.attachment.accepttext':
    'Supports .pdf、.xlsx、.doc、.png、.jpg. Upload up to 5 files, each file not exceeding 10M',
  'demandList.inquiry.btn': 'Inquire Now',
  'demandList.move.title': 'Move to Another List',
  'demandList.move.content':
    'After saving, the currently selected products will be moved to the target demand list. If the list does not exist, you can create it yourself, with a maximum of 7 lists.',
  'demandList.move.input.placeholder': 'Create a requirement list, press Enter to save',
  'demandList.move.unsave': '(not saved)',
  'demandList.move.select.maxlength': 'Up to 7 items created',
  'demandList.move.success': 'Move successful',
  'demandList.versions.current': 'Current',
  'demandList.versions.deleteprompt.title': 'Confirm Deletion',
  'demandList.versions.deleteprompt.content':
    'Once the demand list is deleted, it cannot be recovered. Are you sure you want to delete it?',
  'demandList.versions.edit.title': 'Edit',
  'demandList.versions.input.placeholder': 'Enter',

  'demandList.modal.okText': 'Confirm',
  'demandList.modal.cancelText': 'Cancel',

  'demandList.modal.title.delete': 'Confirm to delete products?',
  'demandList.modal.content.delete': 'After confirmation, the selected products will be deleted.',
  'demandList.modal.title.clear': 'Confirm to clear quantity?',
  'demandList.modal.content.clear':
    'After confirmation, the quantity filled in for the selected products will be reset to 0.',
};

export default locale;
